import {apiGlobal} from './index'

export const paraphraseEndPoints = {
  GET_TOPICS: 'iesv/api/v1/paraphrase/topics',
  GET_SENTENCES: 'iesv/api/v1/paraphrase/topics',
  INIT_SESSIONS: 'iesv/api/v1/paraphrase/sessions',
  GET_PARAPHRASE: 'iesv/api/v1/paraphrase/sessions',
  GET_PARAPHRASE_DATA: 'iesv/api/v1/paraphrase/sessions',
  GET_STATUS: 'iesv/api/v1/paraphrase/guide-status',
  CORRECT_GRAMMARS: 'iesv/api/v1/paraphrase/sessions',
}

export const paraphraseRequest = {
  getTopics: (params: any) => {
    return apiGlobal.authGet(`${paraphraseEndPoints.GET_TOPICS}`, params)
  },
  getSentences: (params: any) => {
    return apiGlobal.authGet(`${paraphraseEndPoints.GET_SENTENCES}/${params.topicId}/sentences`, {})
  },
  initSession: () => {
    return apiGlobal.authPost(`${paraphraseEndPoints.INIT_SESSIONS}`, {})
  },
  getParaphrase: (params: any) => {
    return apiGlobal.authPost(`${paraphraseEndPoints.GET_PARAPHRASE}/${params.sessionId}/sentences/words`, params)
  },
  getParaphraseData: (params: any) => {
    return apiGlobal.authPost(`${paraphraseEndPoints.GET_PARAPHRASE_DATA}/${params.sessionId}/paraphrase-results`, {})
  },
  getStatus: () => {
    return apiGlobal.authGet(`${paraphraseEndPoints.GET_STATUS}`, {})
  },
  correctGrammars: (params: any) => {
    return apiGlobal.authPost(`${paraphraseEndPoints.CORRECT_GRAMMARS}/${params.sessionId}/sentences/correct-grammars`, params)
  },
}
